<template>
<div>
  <h4>Produkty</h4>
  
  <div class="alert alert-info">
    <strong>Informacja</strong>
    Maksymalnie można wyróżnić do 10 produktów
  </div>

  <button class="btn btn-primary" @click="save" style="margin-bottom: 20px;">Zapisz</button>

  <table class="table table-striped table-bordered table-hover">
    <thead>
    <tr>
      <th>Nazwa</th>
      <th>Odmiana</th>
      <th>Pochodzenie</th>
      <th>Wyróżnienie</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(product, index) in products">
      <td>{{ product.name }}</td>
      <td>{{ product.variety }}</td>
      <td>{{ product.origin }}</td>
      <td style="padding: 0;">
        <label style="display: block; cursor: pointer; padding: 10px; margin-bottom: 0;">
          <input type="checkbox" v-model="featured" :value="product.id" :disabled="disabled(product)">
        </label>
      </td>
    </tr>
    </tbody>
  </table>
</div>
</template>
<script>
import Api from './../api'
import Flash from './../Flash'

export default {
  data () {
    return {
      products: [],
      featured: []
    }
  },
  methods: {
    disabled (product) {
      if (this.featured.includes(product.id)) {
        return false
      }
      return this.featured.length >= 10
    },
    fetchData () {
      Api.product.getList().then(this.fetchSuccess)
    },
    fetchSuccess ({body}) {
      this.products = body
      this.featured = body.filter(p => p.featured).map(p => p.id)
    },
    save () {
      Api.product.updateFeatured(this.featured).then(this.onUpdated, this.onError)
    },
    onUpdated ({body}) {
      Flash.success('Zaktualizowano wyróżnienie produktów poprawnie.')
    },
    onError () {
      Flash.error('Nie udało się zaktualizować wyróżnień produktów, skontaktuj się z administratorem')
    }
  },
  created () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// Products.vue?06511215